import {getRegisterInfo, postRegisterInfo} from './register';

export const apiRegister = {
  getRegisterInfo,
  postRegisterInfo,
};
